import { HttpService, UserService } from 'banking-service';

let loginFingerprint = null;
let loginFingerprintAttempt = 0;

const originalPost = HttpService.post.bind(HttpService);

HttpService.post = function patchedPost(url, body, api, ...args) {
  if (
    loginFingerprint &&
    url === 'login' &&
    api === 'termica' &&
    body &&
    typeof body === 'object' &&
    !body.fingerprint
  ) {
    const payload = { ...body, fingerprint: loginFingerprint };
    console.info('[AllowMe] [http] Injetando fingerprint no POST login', {
      hasFingerprint: true,
      fingerprintLength: loginFingerprint.length,
      attempt: loginFingerprintAttempt,
      fingerprintPreview: `${loginFingerprint.slice(0, 8)}...`,
      bodyKeys: Object.keys(payload),
    });
    return originalPost(url, payload, api, ...args);
  }

  return originalPost(url, body, api, ...args);
};

export const clearLoginFingerprint = () => {
  loginFingerprint = null;
};

export async function login(
  document,
  accessPassword,
  clientId,
  accessToken,
  fingerprint
) {
  clearLoginFingerprint();
  loginFingerprint = fingerprint || null;
  if (loginFingerprint) {
    loginFingerprintAttempt += 1;
  }

  try {
    return UserService.login(
      document,
      accessPassword,
      clientId,
      accessToken
    );
  } finally {
    clearLoginFingerprint();
  }
}
